import React, { Dispatch, SetStateAction } from 'react';

/**
 * This hook provides a way to reset a value after a timeout every time it is set
 * @param value default value
 * @param delay delay
 */
export function useTimeout<T>(value?: T, delay = 3000): [T | undefined, Dispatch<SetStateAction<T | undefined>>] {
    const [timeoutValue, setTimeoutValue] = React.useState(value);

    React.useEffect(() => {
        if (!timeoutValue) {
            return;
        }
        const handler = setTimeout(() => {
            setTimeoutValue(undefined);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [timeoutValue, delay]);

    return [timeoutValue, setTimeoutValue];
}
